<template>
  <span>
    <div class="row">
      <div class="col-md-4">
        <label class="col-form-label">Vessel</label>
        <div class="col-sm-12">
          <my-select
            disableFormControl="true"
            :selection.sync="form.vessel_id"
            :suggestions="vessels"
            placeholder="Select Vessel"
          ></my-select>
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Certificate Name</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.certifcate_name"
            class="form-control"
            autocomplete="off"
            placeholder="Certificate Name"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Certificate Number</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.certificate_number"
            class="form-control"
            autocomplete="off"
            placeholder="Certificate Number"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label class="col-form-label">Survey Date</label>
        <div class="col-sm-12">
          <my-datepicker
            :date.sync="form.survey_date"
            placeholder="Enter Survey Date"
          ></my-datepicker>
        </div>
      </div>

      <div class="col-md-4">
        <label class="col-form-label">Survey Type</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.survey_type"
            class="form-control"
            autocomplete="off"
            placeholder="Survey Type"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Certificate Sequence Number</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.certificate_sequence_number"
            class="form-control"
            autocomplete="off"
            placeholder="Certificate Sequence Number"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label class="col-form-label">Survey Carried Out By</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.survey_carried_out_by"
            class="form-control"
            autocomplete="off"
            placeholder="Survey Carried Out By"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Issued By</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.issued_by"
            class="form-control"
            autocomplete="off"
            placeholder="Issued By"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Issued Date</label>
        <div class="col-sm-12">
          <my-datepicker
            :date.sync="form.issued_date"
            placeholder="Enter Issued Date"
          ></my-datepicker>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label class="col-form-label">Expired Date</label>
        <div class="col-sm-12">
          <my-datepicker
            :date.sync="form.expired_date"
            placeholder="Enter Expired Date"
          ></my-datepicker>
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Trigger Alert</label>
        <div class="col-sm-12">
          <div class="form-check form-switch">
            <input
              type="checkbox"
              v-model="form.trigger_alert"
              class="form-check-input"
              id="formSwitch1"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Alert Date</label>
        <div class="col-sm-12">
          <my-datepicker
            :date.sync="form.alert_date"
            placeholder="Enter Alert Date"
          ></my-datepicker>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label class="col-form-label">Place of Issue</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.place_of_issue"
            class="form-control"
            autocomplete="off"
            placeholder="Place of Issue"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Is Active</label>
        <div class="col-sm-12">
          <div class="form-check form-switch">
            <input
              type="checkbox"
              v-model="form.is_active"
              class="form-check-input"
              id="formSwitch1"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Attachment</label>
        <div class="col-sm-12">
          <input
            type="file"
            id="file"
            name="file"
            ref="file"
            accept="application/ms-excel"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="mb-3">
          <label class="col-form-label">Condition</label>
          <div class="col-sm-12">
            <textarea
              name="condition"
              class="form-control"
              id=""
              cols="5"
              rows="5"
              v-model="form.condition"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "OrganizationFormWidget",
  props: ["form"],
  data() {
    return {
      vessels: [],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("vessel_certificates/masters");
      masters = masters.data;
      masters.vessels.forEach((vessel) => {
        this.vessels.push({
          id: vessel.id,
          name: vessel.name,
        });
      });
    },
  },
};
</script>
